var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"wiki-common"},[(!_vm.urlpath.includes('checkrobot.html'))?_c('risk-module'):_vm._e(),_vm._v(" "),_c('nuxt')],1)}
var staticRenderFns = []

export { render, staticRenderFns }